import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/**
 * POST /api/transportista/viajes/cliente/set-values
 * Contrato QAS: multipart/form-data (PascalCase MxTktH, MxNumeroPedidoH, …; archivos).
 * Auth: Bearer únicamente (no header Key).
 */
@Injectable({ providedIn: 'root' })
export class TransportistaViajesClienteSetValuesGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: FormData,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/viajes/cliente/set-values', body, options);
  }
}
